// AI Hub (2026-10-27) — the screen's strings in the portal's four languages. Codes (AI, PDF, Excel, SAP) stay as they are.
const en = {
  placeholderTouch: "Ask Catchy…",
  photo: "Add a photo (camera or gallery)",
  photoAsk: "What is in this photo?",
  movedTo: "Moved to E-Docs {{code}} — Catchy reads it there",
  fromHub: "Catchy Chat",
  bubbleBack: "Back to the chat",
  bubbleConvs: "Your conversations",
  openInHub: "Open Catchy Chat",
  fromBubble: "Ask Catchy",
  showOriginal: 'Show original',
  trMark: 'Translated by AI into your portal language',
  trFailed: 'Could not translate',
  pTitle: 'Whole portal AI spend (admins only)',
  pTotal: 'Total {{a}}',
  pKeys: 'API key for people: {{u}} · for SYSTEM: {{s}}',
  keyOwn: 'its own key',
  keyShared: 'the shared key',
  pByWho: 'By person (SYSTEM = automatic jobs)',
  pByFeature: 'By feature',
  pBySystem: 'SYSTEM, by where it runs',
  pPrices: 'Model prices, USD per million tokens (every new call is costed from this table)',
  kindUser: 'Person',
  kindOld: 'Before 27/10 (not recorded)',
  colCalls: 'Calls',
  colTokIn: 'Tokens in',
  colTokOut: 'Tokens out',
  colFeature: 'Feature',
  colBy: 'By',
  colWhere: 'Where',
  colModel: 'Model',
  colIn: 'Input',
  colOut: 'Output',
  colChanged: 'Last changed',
  change: 'Change',
  nav: 'Catchy Chat',
  navAsk: 'Catchy Chat',
  navSettings: 'Settings',
  backToChat: 'Back to Catchy Chat',
  navKnowledge: 'Knowledge Library',
  navLessons: 'Lessons',
  navActivity: 'Activity',
  title: 'Catchy Chat',
  sub: 'Each department shares its instructions and files, and anyone can ask about them. Every answer shows its sources; a wrong one can be corrected, and once someone approves the correction the AI uses it from then on.',
  tabAsk: 'Catchy Chat',
  tabKnowledge: 'Knowledge Library',
  tabLessons: 'Lessons',
  tabActivity: 'Admin',
  scope: 'Department',
  allDepts: 'All departments',
  general: 'All departments (General)', generalHint: 'applies to every department, also ones added later', generalAdminOnly: 'An Admin decides General lessons',
  placeholder: 'Ask about what the departments shared, or anything in the Portal…',
  send: 'Ask',
  thinking: 'Looking through the documents…',
  think1: 'Claude is reading your question…',
  think2: 'Claude is looking through the documents and the Portal…',
  think3: 'Claude is writing the answer…',
  newChat: 'New conversation',
  emptyAsk: 'Ask a question about the departments\' documents, or about anything in the Portal — SKUs and their stages, samples, tickets, OPA / SCT, sales. The answer shows where it came from.',
  fromPortal: 'From the Portal',
  captured: 'Recorded as a proposed lesson ({{d}})',
  capturedApproved: 'Lesson approved — the AI uses it from now on',
  capturedDropped: 'Lesson dropped',
  approveNow: 'Approve now',
  dropIt: 'Drop it',
  convs: 'Conversations',
  noConvs: 'No saved conversation yet.',
  turns: '{{n}} questions',
  rename: 'Rename',
  delete: 'Delete',
  confirmDelConv: 'Delete "{{t}}" from your list? The questions stay in the Activity log.',
  renamePrompt: 'Name this conversation',
  sources: 'Sources',
  lesson: 'Lesson',
  instruction: 'Instruction',
  approvedBy: 'approved by {{n}}',
  part: 'part {{n}}',
  good: 'Helpful',
  bad: 'Not right',
  rated: 'Thanks — noted.',
  fixTitle: 'What should the answer be?',
  fixSub: 'Write the right answer. It becomes a proposed lesson; once someone approves it in Lessons, the AI uses it.',
  fixNote: 'What was wrong (optional)',
  fixAnswer: 'The right answer',
  fixDept: 'Department it belongs to',
  deptsHint: 'you can pick several',
  deptsPick: 'Choose departments…',
  deptsSearch: 'Search departments',
  deptsChosen: '{{n}} chosen',
  deptsDone: 'Done',
  fixSend: 'Propose the lesson',
  justRate: 'Only rate it',
  cancel: 'Cancel',
  close: 'Close',
  proposed: 'Proposed — the AI uses it once someone approves it in Lessons.',
  depts: 'Departments',
  youManage: 'You keep this one',
  counts: '{{i}} instructions · {{f}} files · {{l}} lessons',
  waiting: '{{n}} waiting',
  instructions: 'Instructions',
  files: 'Files',
  noInstr: 'No instruction yet.',
  noFiles: 'No file yet.',
  newInstr: 'New instruction',
  uploadFile: 'Upload a file',
  colTitle: 'Title',
  colVersion: 'Version',
  colUpdated: 'Updated',
  colBy: 'By',
  colSize: 'Size',
  colAction: 'Action',
  colPassages: 'Passages',
  colNote: 'Note',
  actView: 'View',
  actEdit: 'Edit',
  actNewVersion: 'New version',
  actHistory: 'History',
  actRetire: 'Take out',
  actRestore: 'Put back',
  actDownload: 'Download',
  actRollback: 'Use this version',
  retired: 'Out of use',
  instrTitle: 'Title',
  instrText: 'Instruction',
  instrNote: 'Why this change (kept in the log)',
  instrHint: 'Tell the AI how to answer about this department: the rules, the facts it must use, the tone.',
  save: 'Save',
  fileHint: 'PDF, Word, PowerPoint, Excel, text, CSV or HTML, up to 15 MB. A scanned PDF holds no text to read.',
  fileTitle: 'Title',
  chooseFile: 'Choose a file',
  uploading: 'Reading the file…',
  uploaded: 'Saved v{{v}} — {{p}} passages.',
  readOnly: 'Only this department\'s managers (or a Catchy Chat admin) can change its knowledge.',
  historyTitle: 'History — {{t}}',
  current: 'current',
  confirmRetire: 'Turn "{{t}}" off? Catchy stops using it until it is turned on again.',
  confirmRollback: 'Make v{{v}} the current version again? It is saved as a new version.',
  viewText: 'The text the AI reads',
  lessonsSub: 'A lesson is a corrected answer. A proposed lesson is not used until someone approves it.',
  newLesson: 'Propose a lesson',
  stProposed: 'Proposed',
  stApproved: 'Approved',
  stRejected: 'Rejected',
  stRetired: 'Retired',
  stAll: 'All',
  colQuestion: 'Question',
  colAnswer: 'Right answer',
  colDept: 'Department',
  colProposed: 'Proposed',
  colDecided: 'Decided',
  colStatus: 'Status',
  actApprove: 'Approve',
  actReject: 'Reject',
  actRetireLesson: 'Retire',
  decideTitle: '{{d}} this lesson?',
  decideNote: 'Note (kept in the log)',
  noLessons: 'No lesson here yet.',
  log: 'Change log',
  questions: 'Questions',
  groups: "Group chats",
  gcDigestTitle: "Issues & ideas from group chats (AI)",
  gcDigestHint: "Catchy reads the group chats where it is on and lists the problems, questions and improvement ideas raised, by screen or topic — no names, no quotes. Made with the 16:00 report, or now.",
  gcSummarise: "Summarise now",
  gcSummarised: "Summarised: {{n}} topic(s) from {{m}} messages.",
  gcNothing: "Not enough new messages to summarise.",
  gcNoDigest: "No summary yet.",
  gcPeriod: "{{from}} – {{to}} · {{rooms}} group(s), {{msgs}} messages",
  gcOlder: "Earlier summaries",
  gcKind_problem: "Problem",
  gcKind_question: "Question",
  gcKind_idea: "Idea",
  gcLogTitle: "Catchy in group chats",
  gcLogHint: "Each question to Catchy with its answer and the messages just before it, and each side-window post. Chats between staff only are not listed.",
  gcAllRooms: "All groups",
  colGroup: "Group",
  colAskedBy: "Asked by",
  colCatchyAnswer: "Catchy's answer",
  colContext: "Before it",
  gcSide: "Side window",
  gcNoLog: "Catchy has not answered in any group chat yet.",
  usage: 'AI Data Usage',
  colWhen: 'When',
  colWho: 'Who',
  colWhat: 'What',
  details: 'Details',
  wAddFile: 'Added the file "{{t}}"',
  wAddInstr: 'Added the instruction "{{t}}"',
  wNewFile: 'Uploaded a new version of "{{t}}" (v{{v}})',
  wEditInstr: 'Changed the instruction "{{t}}" (v{{v}})',
  wRetire: 'Turned "{{t}}" off — Catchy no longer uses it',
  wRestore: 'Turned "{{t}}" on — Catchy uses it again',
  wRollback: 'Took "{{t}}" back to v{{from}} (now v{{to}})',
  wPropose: 'Proposed a lesson: "{{q}}"',
  wProposeChat: 'Proposed a lesson from the chat: "{{q}}"',
  wApprove: 'Approved the lesson "{{q}}"',
  wReject: 'Rejected the lesson "{{q}}"',
  wRetireLesson: 'Retired the lesson "{{q}}"',
  wUp: 'Rated the answer to "{{q}}" helpful',
  wDown: 'Rated the answer to "{{q}}" not right',
  wClear: 'Cleared the rating on "{{q}}"',
  dType: 'Type',
  dTitle: 'Title',
  dVersion: 'Version',
  dFrom: 'From',
  dTo: 'To',
  dFile: 'File name',
  dSize: 'Size',
  dChars: 'Text read (characters)',
  dPassages: 'Passages',
  dQuestion: 'Question',
  dAnswer: 'Right answer',
  dStatus: 'Status',
  dProposedBy: 'Proposed by',
  dSaid: 'What was typed in the chat',
  dRating: 'Rating',
  dNote: 'Note',
  dText: 'Text',
  kindFile: 'File',
  kindInstr: 'Instruction',
  before: 'Before',
  after: 'After',
  mineOnly: 'Only mine',
  everybody: 'Everybody\'s',
  fbAll: 'All ratings',
  fbUp: 'Helpful',
  fbDown: 'Not right',
  noRows: 'Nothing yet.',
  spent: 'AI spent today {{a}} of {{c}} (every portal feature together) · this month {{m}}',
  colAsks: 'Questions',
  colCost: 'Cost',
  wholeHub: 'All departments (no department picked)',
  keptOff: 'kept off',
  turnOff: 'Turn off',
  useNow: 'Active right away — Catchy uses this version as soon as it is saved',
  activeOffHint: 'Catchy does not use this document — click to turn it on',
  activeOnHint: 'Catchy uses this document — click to turn it off',
  activeOff: 'Off',
  activeOn: 'On',
  colActive: 'Active',
  search: 'Search…',
  shown: '{{n}} of {{total}}',
  fWhoAll: 'Everyone',
  fKindAll: 'Every kind of change',
  fKindDocs: 'Files & instructions',
  fKindLessons: 'Lessons',
  fKindRatings: 'Ratings',
  loading: 'Loading…',
};
const ko = {
  placeholderTouch: "Catchy에게 질문…",
  photo: "사진 추가 (카메라 또는 앨범)",
  photoAsk: "이 사진에 무엇이 있나요?",
  movedTo: "E-Docs {{code}}(으)로 이동됨 — Catchy는 그 문서를 읽습니다",
  fromHub: "Catchy Chat",
  bubbleBack: "대화로 돌아가기",
  bubbleConvs: "내 대화 목록",
  openInHub: "Catchy Chat 열기",
  fromBubble: "Ask Catchy",
  showOriginal: '원문 보기',
  trMark: 'AI가 포털 언어로 번역함',
  trFailed: '번역하지 못했습니다',
  pTitle: '포털 전체 AI 사용액 (관리자 전용)',
  pTotal: '합계 {{a}}',
  pKeys: '사용자용 API 키: {{u}} · SYSTEM용: {{s}}',
  keyOwn: '전용 키',
  keyShared: '공용 키',
  pByWho: '사람별 (SYSTEM = 자동 작업)',
  pByFeature: '기능별',
  pBySystem: 'SYSTEM, 실행 위치별',
  pPrices: '모델 가격, 백만 토큰당 USD (새 호출 비용은 이 표로 계산)',
  kindUser: '사용자',
  kindOld: '27/10 이전 (기록 없음)',
  colCalls: '호출 수',
  colTokIn: '입력 토큰',
  colTokOut: '출력 토큰',
  colFeature: '기능',
  colBy: '주체',
  colWhere: '위치',
  colModel: '모델',
  colIn: '입력',
  colOut: '출력',
  colChanged: '최근 변경',
  change: '변경',
  nav: 'Catchy Chat',
  navAsk: 'Catchy Chat',
  navSettings: '설정',
  backToChat: 'Catchy Chat으로 돌아가기',
  navKnowledge: 'Knowledge Library',
  navLessons: '교정 내용',
  navActivity: '활동',
  title: 'Catchy Chat',
  sub: '각 부서가 지침과 파일을 공유하고, 누구나 그 내용에 대해 질문할 수 있습니다. 모든 답변에 출처가 표시되며, 틀린 답변은 교정할 수 있고 누군가 승인하면 그때부터 AI가 그 교정을 사용합니다.',
  tabAsk: 'Catchy Chat',
  tabKnowledge: 'Knowledge Library',
  tabLessons: '교정 내용',
  tabActivity: '관리',
  scope: '부서',
  allDepts: '전체 부서',
  general: '전체 부서 (공통)', generalHint: '모든 부서에 적용되며 나중에 추가되는 부서에도 적용됩니다', generalAdminOnly: '공통 레슨은 관리자가 결정합니다',
  placeholder: '부서들이 공유한 내용이나 포털의 모든 정보에 대해 질문하세요…',
  send: '질문',
  thinking: '문서를 살펴보는 중…',
  think1: 'Claude가 질문을 읽는 중…',
  think2: 'Claude가 문서와 포털 데이터를 찾는 중…',
  think3: 'Claude가 답변을 작성하는 중…',
  newChat: '새 대화',
  emptyAsk: '부서 문서나 포털의 정보(SKU와 단계, 샘플, 티켓, OPA / SCT, 매출)에 대해 질문하세요. 답변에 출처가 표시됩니다.',
  fromPortal: '포털 데이터',
  captured: '제안된 교정으로 기록했습니다 ({{d}})',
  capturedApproved: '교정 승인됨 — 이제부터 AI가 사용합니다',
  capturedDropped: '교정을 삭제했습니다',
  approveNow: '지금 승인',
  dropIt: '삭제',
  convs: '대화 목록',
  noConvs: '저장된 대화가 없습니다.',
  turns: '질문 {{n}}개',
  rename: '이름 변경',
  delete: '삭제',
  confirmDelConv: '"{{t}}"을(를) 목록에서 삭제할까요? 질문은 활동 기록에 남습니다.',
  renamePrompt: '대화 이름',
  sources: '출처',
  lesson: '교정',
  instruction: '지침',
  approvedBy: '{{n}} 승인',
  part: '{{n}}번째 부분',
  good: '도움됨',
  bad: '틀림',
  rated: '감사합니다 — 반영했습니다.',
  fixTitle: '올바른 답변은 무엇인가요?',
  fixSub: '올바른 답변을 적어 주세요. 제안된 교정으로 등록되며, 교정 내용 탭에서 누군가 승인하면 AI가 사용합니다.',
  fixNote: '무엇이 틀렸나요 (선택)',
  fixAnswer: '올바른 답변',
  fixDept: '해당 부서',
  deptsHint: '여러 개 선택 가능',
  deptsPick: '부서 선택…',
  deptsSearch: '부서 검색',
  deptsChosen: '{{n}}개 선택',
  deptsDone: '완료',
  fixSend: '교정 제안',
  justRate: '평가만 하기',
  cancel: '취소',
  close: '닫기',
  proposed: '제안됨 — 교정 내용 탭에서 승인되면 AI가 사용합니다.',
  depts: '부서',
  youManage: '내가 관리하는 부서',
  counts: '지침 {{i}} · 파일 {{f}} · 교정 {{l}}',
  waiting: '{{n}}건 대기',
  instructions: '지침',
  files: '파일',
  noInstr: '아직 지침이 없습니다.',
  noFiles: '아직 파일이 없습니다.',
  newInstr: '새 지침',
  uploadFile: '파일 업로드',
  colTitle: '제목',
  colVersion: '버전',
  colUpdated: '수정일',
  colBy: '작성자',
  colSize: '크기',
  colAction: '작업',
  colPassages: '구간',
  colNote: '메모',
  actView: '보기',
  actEdit: '수정',
  actNewVersion: '새 버전',
  actHistory: '이력',
  actRetire: '사용 중지',
  actRestore: '다시 사용',
  actDownload: '다운로드',
  actRollback: '이 버전 사용',
  retired: '사용 중지됨',
  instrTitle: '제목',
  instrText: '지침',
  instrNote: '변경 이유 (기록에 남음)',
  instrHint: '이 부서에 대해 AI가 어떻게 답해야 하는지 적어 주세요: 규칙, 꼭 써야 할 사실, 말투.',
  save: '저장',
  fileHint: 'PDF, Word, PowerPoint, Excel, 텍스트, CSV, HTML (최대 15 MB). 스캔한 PDF에는 읽을 텍스트가 없습니다.',
  fileTitle: '제목',
  chooseFile: '파일 선택',
  uploading: '파일을 읽는 중…',
  uploaded: 'v{{v}} 저장 — {{p}}개 구간.',
  readOnly: '이 부서의 관리자(또는 Catchy Chat 관리자)만 지식을 변경할 수 있습니다.',
  historyTitle: '이력 — {{t}}',
  current: '현재',
  confirmRetire: '"{{t}}"을(를) 끌까요? 다시 켤 때까지 Catchy가 사용하지 않습니다.',
  confirmRollback: 'v{{v}}를 다시 현재 버전으로 할까요? 새 버전으로 저장됩니다.',
  viewText: 'AI가 읽는 텍스트',
  lessonsSub: '교정은 바로잡은 답변입니다. 제안된 교정은 누군가 승인하기 전까지 사용되지 않습니다.',
  newLesson: '교정 제안',
  stProposed: '제안됨',
  stApproved: '승인됨',
  stRejected: '반려됨',
  stRetired: '중지됨',
  stAll: '전체',
  colQuestion: '질문',
  colAnswer: '올바른 답변',
  colDept: '부서',
  colProposed: '제안',
  colDecided: '결정',
  colStatus: '상태',
  actApprove: '승인',
  actReject: '반려',
  actRetireLesson: '중지',
  decideTitle: '이 교정을 {{d}}할까요?',
  decideNote: '메모 (기록에 남음)',
  noLessons: '아직 교정이 없습니다.',
  log: '변경 기록',
  questions: '질문',
  groups: "그룹 채팅",
  gcDigestTitle: "그룹 채팅의 문제점 및 아이디어 (AI)",
  gcDigestHint: "Catchy가 켜져 있는 그룹 채팅을 읽고, 제기된 문제점·질문·개선 아이디어를 화면 또는 주제별로 정리합니다. 이름과 원문 인용은 포함하지 않습니다. 16:00 보고서와 함께, 또는 지금 만들 수 있습니다.",
  gcSummarise: "지금 요약",
  gcSummarised: "요약 완료: 메시지 {{m}}건에서 주제 {{n}}개.",
  gcNothing: "요약할 새 메시지가 충분하지 않습니다.",
  gcNoDigest: "아직 요약이 없습니다.",
  gcPeriod: "{{from}} – {{to}} · 그룹 {{rooms}}개, 메시지 {{msgs}}건",
  gcOlder: "이전 요약",
  gcKind_problem: "문제",
  gcKind_question: "질문",
  gcKind_idea: "아이디어",
  gcLogTitle: "그룹 채팅의 Catchy",
  gcLogHint: "Catchy에게 한 질문과 답변, 그리고 바로 앞의 메시지, 사이드 창 게시물입니다. 직원끼리만 나눈 대화는 표시되지 않습니다.",
  gcAllRooms: "모든 그룹",
  colGroup: "그룹",
  colAskedBy: "질문자",
  colCatchyAnswer: "Catchy 답변",
  colContext: "앞선 메시지",
  gcSide: "사이드 창",
  gcNoLog: "아직 그룹 채팅에서 Catchy가 답변한 내용이 없습니다.",
  usage: 'AI 데이터 사용량',
  colWhen: '일시',
  colWho: '누가',
  colWhat: '내용',
  details: '상세',
  wAddFile: '파일 "{{t}}" 추가',
  wAddInstr: '지침 "{{t}}" 추가',
  wNewFile: '"{{t}}" 새 버전 업로드 (v{{v}})',
  wEditInstr: '지침 "{{t}}" 수정 (v{{v}})',
  wRetire: '"{{t}}" 끔 — Catchy가 더 이상 사용하지 않음',
  wRestore: '"{{t}}" 켬 — Catchy가 다시 사용',
  wRollback: '"{{t}}"를 v{{from}}으로 되돌림 (현재 v{{to}})',
  wPropose: '교정 제안: "{{q}}"',
  wProposeChat: '대화에서 교정 제안: "{{q}}"',
  wApprove: '교정 "{{q}}" 승인',
  wReject: '교정 "{{q}}" 반려',
  wRetireLesson: '교정 "{{q}}" 중지',
  wUp: '"{{q}}" 답변을 도움됨으로 평가',
  wDown: '"{{q}}" 답변을 틀림으로 평가',
  wClear: '"{{q}}" 평가 취소',
  dType: '종류',
  dTitle: '제목',
  dVersion: '버전',
  dFrom: '이전',
  dTo: '이후',
  dFile: '파일 이름',
  dSize: '크기',
  dChars: '읽은 텍스트 (글자 수)',
  dPassages: '구간',
  dQuestion: '질문',
  dAnswer: '올바른 답변',
  dStatus: '상태',
  dProposedBy: '제안자',
  dSaid: '대화에 입력한 내용',
  dRating: '평가',
  dNote: '메모',
  dText: '내용',
  kindFile: '파일',
  kindInstr: '지침',
  before: '변경 전',
  after: '변경 후',
  mineOnly: '내 질문만',
  everybody: '전체',
  fbAll: '모든 평가',
  fbUp: '도움됨',
  fbDown: '틀림',
  noRows: '아직 없습니다.',
  spent: '오늘 AI 사용액 {{a}} / {{c}} (포털 전체 기능 합계) · 이번 달 {{m}}',
  colAsks: '질문 수',
  colCost: '비용',
  wholeHub: '전체 부서 (부서 미선택)',
  keptOff: '꺼진 상태로 저장',
  turnOff: '끄기',
  useNow: '바로 사용 — 저장하는 즉시 Catchy가 이 버전을 사용합니다',
  activeOffHint: 'Catchy가 이 문서를 사용하지 않습니다 — 눌러서 켜기',
  activeOnHint: 'Catchy가 이 문서를 사용합니다 — 눌러서 끄기',
  activeOff: '꺼짐',
  activeOn: '켜짐',
  colActive: '사용',
  search: '검색…',
  shown: '{{total}}개 중 {{n}}개',
  fWhoAll: '모든 사람',
  fKindAll: '모든 변경 종류',
  fKindDocs: '파일 및 지침',
  fKindLessons: '교정',
  fKindRatings: '평가',
  loading: '불러오는 중…',
};
const vi = {
  placeholderTouch: "Hỏi Catchy…",
  photo: "Thêm ảnh (chụp hoặc chọn từ máy)",
  photoAsk: "Ảnh này có gì?",
  movedTo: "Đã chuyển sang E-Docs {{code}} — Catchy đọc bản ở đó",
  fromHub: "Catchy Chat",
  bubbleBack: "Quay lại chat",
  bubbleConvs: "Các cuộc chat của bạn",
  openInHub: "Mở Catchy Chat",
  fromBubble: "Ask Catchy",
  showOriginal: 'Xem bản gốc',
  trMark: 'AI dịch sang ngôn ngữ portal của bạn',
  trFailed: 'Không dịch được',
  pTitle: 'Chi phí AI toàn portal (chỉ admin)',
  pTotal: 'Tổng {{a}}',
  pKeys: 'API key cho người dùng: {{u}} · cho SYSTEM: {{s}}',
  keyOwn: 'key riêng',
  keyShared: 'key dùng chung',
  pByWho: 'Theo người (SYSTEM = job tự động)',
  pByFeature: 'Theo tính năng',
  pBySystem: 'SYSTEM, theo nơi chạy',
  pPrices: 'Giá model, USD cho mỗi triệu token (mọi lượt gọi mới tính tiền theo bảng này)',
  kindUser: 'Người dùng',
  kindOld: 'Trước 27/10 (chưa ghi)',
  colCalls: 'Lượt gọi',
  colTokIn: 'Token vào',
  colTokOut: 'Token ra',
  colFeature: 'Tính năng',
  colBy: 'Ai gọi',
  colWhere: 'Nơi chạy',
  colModel: 'Model',
  colIn: 'Đầu vào',
  colOut: 'Đầu ra',
  colChanged: 'Sửa lần cuối',
  change: 'Sửa',
  nav: 'Catchy Chat',
  navAsk: 'Catchy Chat',
  navSettings: 'Cài đặt',
  backToChat: 'Quay lại Catchy Chat',
  navKnowledge: 'Knowledge Library',
  navLessons: 'Bài học',
  navActivity: 'Hoạt động',
  title: 'Catchy Chat',
  sub: 'Mỗi department chia sẻ instruction và file của mình, ai cũng hỏi được về các nội dung đó. Câu trả lời nào cũng kèm nguồn; câu sai thì sửa được, và khi có người duyệt bản sửa thì AI dùng nó từ đó về sau.',
  tabAsk: 'Catchy Chat',
  tabKnowledge: 'Knowledge Library',
  tabLessons: 'Bài học',
  tabActivity: 'Quản trị',
  scope: 'Department',
  allDepts: 'Tất cả department',
  general: 'Tất cả department (Chung)', generalHint: 'áp dụng cho mọi department, kể cả department thêm sau này', generalAdminOnly: 'Lesson Chung do Admin quyết định',
  placeholder: 'Hỏi về nội dung các department đã chia sẻ, hoặc bất cứ thông tin nào trên portal…',
  send: 'Hỏi',
  thinking: 'Đang tìm trong tài liệu…',
  think1: 'Claude đang đọc câu hỏi…',
  think2: 'Claude đang tìm trong tài liệu và dữ liệu portal…',
  think3: 'Claude đang soạn câu trả lời…',
  newChat: 'Cuộc hội thoại mới',
  emptyAsk: 'Hãy hỏi về tài liệu của các department, hoặc bất cứ thông tin nào trên portal — SKU và các stage, sample, ticket, OPA / SCT, doanh số. Câu trả lời ghi rõ lấy từ đâu.',
  fromPortal: 'Từ portal',
  captured: 'Đã ghi nhận thành bài học đề xuất ({{d}})',
  capturedApproved: 'Đã duyệt bài học — AI dùng từ bây giờ',
  capturedDropped: 'Đã bỏ bài học',
  approveNow: 'Duyệt ngay',
  dropIt: 'Bỏ',
  convs: 'Cuộc hội thoại',
  noConvs: 'Chưa có cuộc hội thoại nào.',
  turns: '{{n}} câu hỏi',
  rename: 'Đổi tên',
  delete: 'Xóa',
  confirmDelConv: 'Xóa "{{t}}" khỏi danh sách của bạn? Các câu hỏi vẫn còn trong nhật ký ở tab Hoạt động.',
  renamePrompt: 'Đặt tên cho cuộc hội thoại',
  sources: 'Nguồn',
  lesson: 'Bài học',
  instruction: 'Instruction',
  approvedBy: '{{n}} đã duyệt',
  part: 'phần {{n}}',
  good: 'Hữu ích',
  bad: 'Chưa đúng',
  rated: 'Cảm ơn — đã ghi nhận.',
  fixTitle: 'Câu trả lời đúng là gì?',
  fixSub: 'Viết câu trả lời đúng. Nó thành một bài học đề xuất; khi có người duyệt ở tab Bài học, AI sẽ dùng nó.',
  fixNote: 'Sai ở đâu (không bắt buộc)',
  fixAnswer: 'Câu trả lời đúng',
  fixDept: 'Thuộc department',
  deptsHint: 'chọn được nhiều cái',
  deptsPick: 'Chọn department…',
  deptsSearch: 'Tìm department',
  deptsChosen: 'Đã chọn {{n}}',
  deptsDone: 'Xong',
  fixSend: 'Đề xuất bài học',
  justRate: 'Chỉ đánh giá',
  cancel: 'Huỷ',
  close: 'Đóng',
  proposed: 'Đã đề xuất — AI dùng khi có người duyệt ở tab Bài học.',
  depts: 'Department',
  youManage: 'Bạn quản lý',
  counts: '{{i}} instruction · {{f}} file · {{l}} bài học',
  waiting: '{{n}} chờ duyệt',
  instructions: 'Instruction',
  files: 'File',
  noInstr: 'Chưa có instruction.',
  noFiles: 'Chưa có file.',
  newInstr: 'Instruction mới',
  uploadFile: 'Tải file lên',
  colTitle: 'Tiêu đề',
  colVersion: 'Phiên bản',
  colUpdated: 'Cập nhật',
  colBy: 'Người làm',
  colSize: 'Dung lượng',
  colAction: 'Thao tác',
  colPassages: 'Đoạn',
  colNote: 'Ghi chú',
  actView: 'Xem',
  actEdit: 'Sửa',
  actNewVersion: 'Bản mới',
  actHistory: 'Lịch sử',
  actRetire: 'Ngừng dùng',
  actRestore: 'Dùng lại',
  actDownload: 'Tải về',
  actRollback: 'Dùng bản này',
  retired: 'Đã ngừng dùng',
  instrTitle: 'Tiêu đề',
  instrText: 'Instruction',
  instrNote: 'Lý do thay đổi (lưu vào nhật ký)',
  instrHint: 'Dặn AI cách trả lời về department này: quy tắc, thông tin bắt buộc dùng, giọng văn.',
  save: 'Lưu',
  fileHint: 'PDF, Word, PowerPoint, Excel, text, CSV hoặc HTML, tối đa 15 MB. PDF scan không có chữ để đọc.',
  fileTitle: 'Tiêu đề',
  chooseFile: 'Chọn file',
  uploading: 'Đang đọc file…',
  uploaded: 'Đã lưu v{{v}} — {{p}} đoạn.',
  readOnly: 'Chỉ manager của department này (hoặc admin Catchy Chat) mới sửa được kho kiến thức.',
  historyTitle: 'Lịch sử — {{t}}',
  current: 'hiện hành',
  confirmRetire: 'Tắt "{{t}}"? Catchy sẽ không dùng tài liệu này cho đến khi bật lại.',
  confirmRollback: 'Đưa v{{v}} về làm bản hiện hành? Sẽ được lưu thành một bản mới.',
  viewText: 'Nội dung AI đọc',
  lessonsSub: 'Bài học là câu trả lời đã được sửa. Bài học đề xuất chưa được dùng cho đến khi có người duyệt.',
  newLesson: 'Đề xuất bài học',
  stProposed: 'Đề xuất',
  stApproved: 'Đã duyệt',
  stRejected: 'Từ chối',
  stRetired: 'Ngừng dùng',
  stAll: 'Tất cả',
  colQuestion: 'Câu hỏi',
  colAnswer: 'Câu trả lời đúng',
  colDept: 'Department',
  colProposed: 'Đề xuất',
  colDecided: 'Quyết định',
  colStatus: 'Trạng thái',
  actApprove: 'Duyệt',
  actReject: 'Từ chối',
  actRetireLesson: 'Ngừng dùng',
  decideTitle: '{{d}} bài học này?',
  decideNote: 'Ghi chú (lưu vào nhật ký)',
  noLessons: 'Chưa có bài học.',
  log: 'Nhật ký thay đổi',
  questions: 'Câu hỏi',
  groups: "Group chat",
  gcDigestTitle: "Vấn đề & ý tưởng từ Group chat (AI)",
  gcDigestHint: "Catchy đọc các nhóm chat đang bật Catchy và liệt kê vấn đề, câu hỏi, ý tưởng cải thiện được nêu ra, theo màn hình hoặc chủ đề — không nêu tên, không trích nguyên văn. Tạo cùng báo cáo 16:00, hoặc tạo ngay.",
  gcSummarise: "Tóm tắt ngay",
  gcSummarised: "Đã tóm tắt: {{n}} chủ đề từ {{m}} tin nhắn.",
  gcNothing: "Chưa đủ tin nhắn mới để tóm tắt.",
  gcNoDigest: "Chưa có bản tóm tắt nào.",
  gcPeriod: "{{from}} – {{to}} · {{rooms}} nhóm, {{msgs}} tin nhắn",
  gcOlder: "Các bản tóm tắt trước",
  gcKind_problem: "Vấn đề",
  gcKind_question: "Câu hỏi",
  gcKind_idea: "Ý tưởng",
  gcLogTitle: "Catchy trong Group chat",
  gcLogHint: "Mỗi câu hỏi gửi Catchy kèm câu trả lời và vài tin nhắn ngay trước đó, cùng các bài Catchy đăng ở cửa sổ bên. Tin nhắn chỉ giữa nhân viên với nhau không hiện ở đây.",
  gcAllRooms: "Tất cả nhóm",
  colGroup: "Nhóm",
  colAskedBy: "Người hỏi",
  colCatchyAnswer: "Catchy trả lời",
  colContext: "Tin nhắn trước đó",
  gcSide: "Cửa sổ bên",
  gcNoLog: "Catchy chưa trả lời trong nhóm chat nào.",
  usage: 'Dữ liệu sử dụng AI',
  colWhen: 'Thời gian',
  colWho: 'Ai',
  colWhat: 'Nội dung',
  details: 'Chi tiết',
  wAddFile: 'Đã thêm file "{{t}}"',
  wAddInstr: 'Đã thêm instruction "{{t}}"',
  wNewFile: 'Đã tải bản mới của "{{t}}" (v{{v}})',
  wEditInstr: 'Đã sửa instruction "{{t}}" (v{{v}})',
  wRetire: 'Đã tắt "{{t}}" — Catchy không dùng nữa',
  wRestore: 'Đã bật "{{t}}" — Catchy dùng lại',
  wRollback: 'Đã đưa "{{t}}" về v{{from}} (giờ là v{{to}})',
  wPropose: 'Đã đề xuất bài học: "{{q}}"',
  wProposeChat: 'Đã đề xuất bài học từ chat: "{{q}}"',
  wApprove: 'Đã duyệt bài học "{{q}}"',
  wReject: 'Đã từ chối bài học "{{q}}"',
  wRetireLesson: 'Đã ngừng dùng bài học "{{q}}"',
  wUp: 'Đánh giá câu trả lời cho "{{q}}" là hữu ích',
  wDown: 'Đánh giá câu trả lời cho "{{q}}" là chưa đúng',
  wClear: 'Đã bỏ đánh giá cho "{{q}}"',
  dType: 'Loại',
  dTitle: 'Tiêu đề',
  dVersion: 'Phiên bản',
  dFrom: 'Từ',
  dTo: 'Thành',
  dFile: 'Tên file',
  dSize: 'Dung lượng',
  dChars: 'Số ký tự đã đọc',
  dPassages: 'Số đoạn',
  dQuestion: 'Câu hỏi',
  dAnswer: 'Câu trả lời đúng',
  dStatus: 'Trạng thái',
  dProposedBy: 'Người đề xuất',
  dSaid: 'Nội dung đã gõ trong chat',
  dRating: 'Đánh giá',
  dNote: 'Ghi chú',
  dText: 'Nội dung',
  kindFile: 'File',
  kindInstr: 'Instruction',
  before: 'Trước',
  after: 'Sau',
  mineOnly: 'Chỉ của tôi',
  everybody: 'Của mọi người',
  fbAll: 'Mọi đánh giá',
  fbUp: 'Hữu ích',
  fbDown: 'Chưa đúng',
  noRows: 'Chưa có gì.',
  spent: 'Chi phí AI hôm nay {{a}} / {{c}} (mọi tính năng portal) · tháng này {{m}}',
  colAsks: 'Số câu hỏi',
  colCost: 'Chi phí',
  wholeHub: 'Tất cả department (không chọn)',
  keptOff: 'để tắt',
  turnOff: 'Tắt',
  useNow: 'Dùng ngay — Catchy dùng phiên bản này ngay khi lưu',
  activeOffHint: 'Catchy không dùng tài liệu này — bấm để bật',
  activeOnHint: 'Catchy đang dùng tài liệu này — bấm để tắt',
  activeOff: 'Tắt',
  activeOn: 'Bật',
  colActive: 'Active',
  search: 'Tìm kiếm…',
  shown: '{{n}} / {{total}}',
  fWhoAll: 'Mọi người',
  fKindAll: 'Mọi loại thay đổi',
  fKindDocs: 'File & instruction',
  fKindLessons: 'Bài học',
  fKindRatings: 'Đánh giá',
  loading: 'Đang tải…',
};
const zh = {
  placeholderTouch: "问 Catchy…",
  photo: "添加照片（拍照或相册）",
  photoAsk: "这张照片里是什么？",
  movedTo: "已移至 E-Docs {{code}} — Catchy 读取那里的文件",
  fromHub: "Catchy Chat",
  bubbleBack: "返回对话",
  bubbleConvs: "我的对话",
  openInHub: "打开 Catchy Chat",
  fromBubble: "Ask Catchy",
  showOriginal: '查看原文',
  trMark: '由 AI 翻译为您的门户语言',
  trFailed: '无法翻译',
  pTitle: '门户 AI 总花费（仅管理员）',
  pTotal: '合计 {{a}}',
  pKeys: '用户 API 密钥：{{u}} · SYSTEM：{{s}}',
  keyOwn: '专用密钥',
  keyShared: '共用密钥',
  pByWho: '按人员（SYSTEM = 自动任务）',
  pByFeature: '按功能',
  pBySystem: 'SYSTEM，按运行位置',
  pPrices: '模型价格，每百万 token 美元（新调用按此表计费）',
  kindUser: '用户',
  kindOld: '27/10 之前（未记录）',
  colCalls: '调用次数',
  colTokIn: '输入 token',
  colTokOut: '输出 token',
  colFeature: '功能',
  colBy: '调用方',
  colWhere: '运行位置',
  colModel: '模型',
  colIn: '输入',
  colOut: '输出',
  colChanged: '最近修改',
  change: '修改',
  nav: 'Catchy Chat',
  navAsk: 'Catchy Chat',
  navSettings: '设置',
  backToChat: '返回 Catchy Chat',
  navKnowledge: 'Knowledge Library',
  navLessons: '修正',
  navActivity: '活动',
  title: 'Catchy Chat',
  sub: '各部门分享自己的指示和文件，任何人都可以就这些内容提问。每个回答都显示出处；错误的回答可以修正，一旦有人批准修正，AI 从此使用它。',
  tabAsk: 'Catchy Chat',
  tabKnowledge: 'Knowledge Library',
  tabLessons: '修正',
  tabActivity: '管理',
  scope: '部门',
  allDepts: '所有部门',
  general: '所有部门（通用）', generalHint: '适用于所有部门，包括以后新增的部门', generalAdminOnly: '通用课程由管理员决定',
  placeholder: '就各部门分享的内容或门户中的任何信息提问…',
  send: '提问',
  thinking: '正在查阅文件…',
  think1: 'Claude 正在阅读问题…',
  think2: 'Claude 正在查找文件和门户数据…',
  think3: 'Claude 正在撰写回答…',
  newChat: '新对话',
  emptyAsk: '可以询问各部门的文件，或门户中的任何信息 — SKU 及其阶段、样品、工单、OPA / SCT、销售。回答会注明出处。',
  fromPortal: '来自门户',
  captured: '已记录为待批准的修正（{{d}}）',
  capturedApproved: '修正已批准 — AI 从现在起使用',
  capturedDropped: '已放弃该修正',
  approveNow: '立即批准',
  dropIt: '放弃',
  convs: '对话',
  noConvs: '还没有保存的对话。',
  turns: '{{n}} 个问题',
  rename: '重命名',
  delete: '删除',
  confirmDelConv: '从列表中删除“{{t}}”？问题仍保留在活动日志中。',
  renamePrompt: '为对话命名',
  sources: '出处',
  lesson: '修正',
  instruction: '指示',
  approvedBy: '{{n}} 已批准',
  part: '第 {{n}} 部分',
  good: '有帮助',
  bad: '不正确',
  rated: '谢谢，已记录。',
  fixTitle: '正确的回答是什么？',
  fixSub: '写下正确的回答。它会成为待批准的修正；在“修正”中有人批准后，AI 就会使用它。',
  fixNote: '哪里不对（可选）',
  fixAnswer: '正确的回答',
  fixDept: '所属部门',
  deptsHint: '可多选',
  deptsPick: '选择部门…',
  deptsSearch: '搜索部门',
  deptsChosen: '已选 {{n}} 个',
  deptsDone: '完成',
  fixSend: '提交修正',
  justRate: '仅评价',
  cancel: '取消',
  close: '关闭',
  proposed: '已提交 — 在“修正”中被批准后 AI 才会使用。',
  depts: '部门',
  youManage: '由你管理',
  counts: '{{i}} 条指示 · {{f}} 个文件 · {{l}} 条修正',
  waiting: '{{n}} 条待批',
  instructions: '指示',
  files: '文件',
  noInstr: '还没有指示。',
  noFiles: '还没有文件。',
  newInstr: '新指示',
  uploadFile: '上传文件',
  colTitle: '标题',
  colVersion: '版本',
  colUpdated: '更新',
  colBy: '操作人',
  colSize: '大小',
  colAction: '操作',
  colPassages: '段落',
  colNote: '备注',
  actView: '查看',
  actEdit: '编辑',
  actNewVersion: '新版本',
  actHistory: '历史',
  actRetire: '停用',
  actRestore: '恢复使用',
  actDownload: '下载',
  actRollback: '使用此版本',
  retired: '已停用',
  instrTitle: '标题',
  instrText: '指示',
  instrNote: '修改原因（记入日志）',
  instrHint: '告诉 AI 如何回答本部门的问题：规则、必须使用的事实、语气。',
  save: '保存',
  fileHint: 'PDF、Word、PowerPoint、Excel、文本、CSV 或 HTML，最大 15 MB。扫描的 PDF 没有可读文字。',
  fileTitle: '标题',
  chooseFile: '选择文件',
  uploading: '正在读取文件…',
  uploaded: '已保存 v{{v}} — {{p}} 个段落。',
  readOnly: '只有本部门的经理（或 Catchy Chat 管理员）可以修改其知识库。',
  historyTitle: '历史 — {{t}}',
  current: '当前',
  confirmRetire: '关闭“{{t}}”？在重新开启之前 Catchy 不会使用它。',
  confirmRollback: '把 v{{v}} 重新设为当前版本？它会保存为一个新版本。',
  viewText: 'AI 读取的文字',
  lessonsSub: '修正是改正后的回答。待批准的修正在有人批准前不会被使用。',
  newLesson: '提交修正',
  stProposed: '待批准',
  stApproved: '已批准',
  stRejected: '已拒绝',
  stRetired: '已停用',
  stAll: '全部',
  colQuestion: '问题',
  colAnswer: '正确回答',
  colDept: '部门',
  colProposed: '提交',
  colDecided: '决定',
  colStatus: '状态',
  actApprove: '批准',
  actReject: '拒绝',
  actRetireLesson: '停用',
  decideTitle: '{{d}}这条修正？',
  decideNote: '备注（记入日志）',
  noLessons: '还没有修正。',
  log: '变更日志',
  questions: '问题',
  groups: "群聊",
  gcDigestTitle: "群聊中的问题与想法 (AI)",
  gcDigestHint: "Catchy 阅读已开启 Catchy 的群聊，按页面或主题列出提出的问题、疑问和改进想法——不含姓名，不引用原文。随 16:00 报告生成，也可立即生成。",
  gcSummarise: "立即汇总",
  gcSummarised: "已汇总：从 {{m}} 条消息中整理出 {{n}} 个主题。",
  gcNothing: "新消息不足，无法汇总。",
  gcNoDigest: "暂无汇总。",
  gcPeriod: "{{from}} – {{to}} · {{rooms}} 个群，{{msgs}} 条消息",
  gcOlder: "较早的汇总",
  gcKind_problem: "问题",
  gcKind_question: "疑问",
  gcKind_idea: "想法",
  gcLogTitle: "群聊中的 Catchy",
  gcLogHint: "每个向 Catchy 提出的问题、它的回答及之前的几条消息，以及侧边窗口的发帖。仅员工之间的对话不会列出。",
  gcAllRooms: "所有群",
  colGroup: "群",
  colAskedBy: "提问人",
  colCatchyAnswer: "Catchy 的回答",
  colContext: "之前的消息",
  gcSide: "侧边窗口",
  gcNoLog: "Catchy 尚未在任何群聊中回答。",
  usage: 'AI 数据用量',
  colWhen: '时间',
  colWho: '谁',
  colWhat: '内容',
  details: '详情',
  wAddFile: '添加了文件“{{t}}”',
  wAddInstr: '添加了指示“{{t}}”',
  wNewFile: '上传了“{{t}}”的新版本（v{{v}}）',
  wEditInstr: '修改了指示“{{t}}”（v{{v}}）',
  wRetire: '关闭了“{{t}}” — Catchy 不再使用',
  wRestore: '开启了“{{t}}” — Catchy 重新使用',
  wRollback: '将“{{t}}”恢复到 v{{from}}（现为 v{{to}}）',
  wPropose: '提交了修正：“{{q}}”',
  wProposeChat: '从对话中提交了修正：“{{q}}”',
  wApprove: '批准了修正“{{q}}”',
  wReject: '拒绝了修正“{{q}}”',
  wRetireLesson: '停用了修正“{{q}}”',
  wUp: '将“{{q}}”的回答评为有帮助',
  wDown: '将“{{q}}”的回答评为不正确',
  wClear: '取消了“{{q}}”的评价',
  dType: '类型',
  dTitle: '标题',
  dVersion: '版本',
  dFrom: '从',
  dTo: '到',
  dFile: '文件名',
  dSize: '大小',
  dChars: '读取的文字（字符数）',
  dPassages: '段落',
  dQuestion: '问题',
  dAnswer: '正确回答',
  dStatus: '状态',
  dProposedBy: '提交人',
  dSaid: '对话中输入的内容',
  dRating: '评价',
  dNote: '备注',
  dText: '内容',
  kindFile: '文件',
  kindInstr: '指示',
  before: '修改前',
  after: '修改后',
  mineOnly: '只看我的',
  everybody: '所有人的',
  fbAll: '所有评价',
  fbUp: '有帮助',
  fbDown: '不正确',
  noRows: '暂无。',
  spent: '今日 AI 花费 {{a}} / {{c}}（门户所有功能合计）· 本月 {{m}}',
  colAsks: '问题数',
  colCost: '费用',
  wholeHub: '所有部门（未选部门）',
  keptOff: '保存为关闭',
  turnOff: '关闭',
  useNow: '立即启用 — 保存后 Catchy 立即使用此版本',
  activeOffHint: 'Catchy 不使用此文件 — 点击开启',
  activeOnHint: 'Catchy 正在使用此文件 — 点击关闭',
  activeOff: '关',
  activeOn: '开',
  colActive: '启用',
  search: '搜索…',
  shown: '{{total}} 条中的 {{n}} 条',
  fWhoAll: '所有人',
  fKindAll: '所有变更类型',
  fKindDocs: '文件和指示',
  fKindLessons: '修正',
  fKindRatings: '评价',
  loading: '加载中…',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "placeholderTouch": "Demander à Catchy…",
  "photo": "Ajouter une photo (appareil photo ou galerie)",
  "photoAsk": "Que voit-on sur cette photo ?",
  "movedTo": "Déplacé vers E-Docs {{code}} — Catchy le lit à cet endroit",
  "fromHub": "Catchy Chat",
  "bubbleBack": "Retour au chat",
  "bubbleConvs": "Vos conversations",
  "openInHub": "Ouvrir Catchy Chat",
  "fromBubble": "Ask Catchy",
  "showOriginal": "Afficher l'original",
  "trMark": "Traduit par l'IA dans la langue de votre portail",
  "trFailed": "Traduction impossible",
  "pTitle": "Dépenses IA de l'ensemble du portail (admins uniquement)",
  "pTotal": "Total {{a}}",
  "pKeys": "Clé API pour les personnes : {{u}} · pour SYSTEM : {{s}}",
  "keyOwn": "sa propre clé",
  "keyShared": "la clé partagée",
  "pByWho": "Par personne (SYSTEM = tâches automatiques)",
  "pByFeature": "Par fonctionnalité",
  "pBySystem": "SYSTEM, par lieu d'exécution",
  "pPrices": "Prix des modèles, USD par million de tokens (chaque nouvel appel est valorisé à partir de ce tableau)",
  "kindUser": "Personne",
  "kindOld": "Avant le 27/10 (non enregistré)",
  "colCalls": "Appels",
  "colTokIn": "Tokens en entrée",
  "colTokOut": "Tokens en sortie",
  "colFeature": "Fonctionnalité",
  "colBy": "Par",
  "colWhere": "Lieu",
  "colModel": "Modèle",
  "colIn": "Entrée",
  "colOut": "Sortie",
  "colChanged": "Dernière modification",
  "change": "Modifier",
  "nav": "Catchy Chat",
  "navAsk": "Catchy Chat",
  "navSettings": "Paramètres",
  "backToChat": "Retour à Catchy Chat",
  "navKnowledge": "Knowledge Library",
  "navLessons": "Leçons",
  "navActivity": "Activité",
  "title": "Catchy Chat",
  "sub": "Chaque département partage ses instructions et ses fichiers, et chacun peut poser des questions à leur sujet. Chaque réponse indique ses sources ; une réponse erronée peut être corrigée, et dès que quelqu'un approuve la correction, l'IA l'utilise.",
  "tabAsk": "Catchy Chat",
  "tabKnowledge": "Knowledge Library",
  "tabLessons": "Leçons",
  "tabActivity": "Admin",
  "scope": "Département",
  "allDepts": "Tous les départements",
  "general": "Tous les départements (Général)",
  "generalHint": "s'applique à tous les départements, y compris ceux ajoutés plus tard",
  "generalAdminOnly": "Un Admin décide des leçons Générales",
  "placeholder": "Posez une question sur ce que les départements ont partagé, ou sur tout ce qui se trouve dans le portail…",
  "send": "Demander",
  "thinking": "Recherche dans les documents…",
  "think1": "Claude lit votre question…",
  "think2": "Claude consulte les documents et le portail…",
  "think3": "Claude rédige la réponse…",
  "newChat": "Nouvelle conversation",
  "emptyAsk": "Posez une question sur les documents des départements ou sur tout ce qui se trouve dans le portail : SKU et leurs étapes, échantillons, tickets, OPA / SCT, ventes. La réponse indique sa provenance.",
  "fromPortal": "Depuis le portail",
  "captured": "Enregistré comme leçon proposée ({{d}})",
  "capturedApproved": "Leçon approuvée — l'IA l'utilise désormais",
  "capturedDropped": "Leçon abandonnée",
  "approveNow": "Approuver maintenant",
  "dropIt": "Abandonner",
  "convs": "Conversations",
  "noConvs": "Aucune conversation enregistrée pour l'instant.",
  "turns": "{{n}} questions",
  "rename": "Renommer",
  "delete": "Supprimer",
  "confirmDelConv": "Supprimer « {{t}} » de votre liste ? Les questions restent dans le journal d'activité.",
  "renamePrompt": "Nommez cette conversation",
  "sources": "Sources",
  "lesson": "Leçon",
  "instruction": "Instruction",
  "approvedBy": "approuvé par {{n}}",
  "part": "partie {{n}}",
  "good": "Utile",
  "bad": "Incorrect",
  "rated": "Merci, c'est noté.",
  "fixTitle": "Quelle devrait être la réponse ?",
  "fixSub": "Rédigez la bonne réponse. Elle devient une leçon proposée ; dès que quelqu'un l'approuve dans Leçons, l'IA l'utilise.",
  "fixNote": "Ce qui n'allait pas (facultatif)",
  "fixAnswer": "La bonne réponse",
  "fixDept": "Département concerné",
  "deptsHint": "vous pouvez en choisir plusieurs",
  "deptsPick": "Choisir des départements…",
  "deptsSearch": "Rechercher des départements",
  "deptsChosen": "{{n}} choisi(s)",
  "deptsDone": "Terminé",
  "fixSend": "Proposer la leçon",
  "justRate": "Seulement noter",
  "cancel": "Annuler",
  "close": "Fermer",
  "proposed": "Proposée — l'IA l'utilise dès que quelqu'un l'approuve dans Leçons.",
  "depts": "Départements",
  "youManage": "Vous gérez celui-ci",
  "counts": "{{i}} instructions · {{f}} fichiers · {{l}} leçons",
  "waiting": "{{n}} en attente",
  "instructions": "Instructions",
  "files": "Fichiers",
  "noInstr": "Aucune instruction pour l'instant.",
  "noFiles": "Aucun fichier pour l'instant.",
  "newInstr": "Nouvelle instruction",
  "uploadFile": "Importer un fichier",
  "colTitle": "Titre",
  "colVersion": "Version",
  "colUpdated": "Mis à jour",
  "colSize": "Taille",
  "colAction": "Action",
  "colPassages": "Passages",
  "colNote": "Remarque",
  "actView": "Voir",
  "actEdit": "Modifier",
  "actNewVersion": "Nouvelle version",
  "actHistory": "Historique",
  "actRetire": "Retirer",
  "actRestore": "Remettre",
  "actDownload": "Télécharger",
  "actRollback": "Utiliser cette version",
  "retired": "Hors service",
  "instrTitle": "Titre",
  "instrText": "Instruction",
  "instrNote": "Pourquoi cette modification (conservé dans le journal)",
  "instrHint": "Indiquez à l'IA comment répondre au sujet de ce département : les règles, les faits à utiliser, le ton.",
  "save": "Enregistrer",
  "fileHint": "PDF, Word, PowerPoint, Excel, texte, CSV ou HTML, jusqu'à 15 MB. Un PDF numérisé ne contient aucun texte lisible.",
  "fileTitle": "Titre",
  "chooseFile": "Choisir un fichier",
  "uploading": "Lecture du fichier…",
  "uploaded": "v{{v}} enregistrée — {{p}} passages.",
  "readOnly": "Seuls les responsables de ce département (ou un admin de Catchy Chat) peuvent modifier ses connaissances.",
  "historyTitle": "Historique — {{t}}",
  "current": "actuelle",
  "confirmRetire": "Désactiver « {{t}} » ? Catchy cesse de l'utiliser jusqu'à sa réactivation.",
  "confirmRollback": "Rétablir la v{{v}} comme version actuelle ? Elle est enregistrée comme nouvelle version.",
  "viewText": "Le texte lu par l'IA",
  "lessonsSub": "Une leçon est une réponse corrigée. Une leçon proposée n'est pas utilisée tant que quelqu'un ne l'a pas approuvée.",
  "newLesson": "Proposer une leçon",
  "stProposed": "Proposée",
  "stApproved": "Approuvée",
  "stRejected": "Rejetée",
  "stRetired": "Retirée",
  "stAll": "Toutes",
  "colQuestion": "Question",
  "colAnswer": "Bonne réponse",
  "colDept": "Département",
  "colProposed": "Proposée le",
  "colDecided": "Décidée le",
  "colStatus": "Statut",
  "actApprove": "Approuver",
  "actReject": "Rejeter",
  "actRetireLesson": "Retirer",
  "decideTitle": "{{d}} cette leçon ?",
  "decideNote": "Remarque (conservée dans le journal)",
  "noLessons": "Aucune leçon pour l'instant.",
  "log": "Journal des modifications",
  "questions": "Questions",
  "groups": "Chats de groupe",
  "gcDigestTitle": "Problèmes et idées issus des chats de groupe (IA)",
  "gcDigestHint": "Catchy lit les chats de groupe où il est activé et liste les problèmes, questions et idées d'amélioration soulevés, par écran ou par sujet — sans noms ni citations. Généré avec le rapport de 16:00, ou à la demande.",
  "gcSummarise": "Résumer maintenant",
  "gcSummarised": "Résumé : {{n}} sujet(s) à partir de {{m}} messages.",
  "gcNothing": "Pas assez de nouveaux messages à résumer.",
  "gcNoDigest": "Aucun résumé pour l'instant.",
  "gcPeriod": "{{from}} – {{to}} · {{rooms}} groupe(s), {{msgs}} messages",
  "gcOlder": "Résumés précédents",
  "gcKind_problem": "Problème",
  "gcKind_question": "Question",
  "gcKind_idea": "Idée",
  "gcLogTitle": "Catchy dans les chats de groupe",
  "gcLogHint": "Chaque question posée à Catchy avec sa réponse et les messages qui la précèdent, ainsi que chaque message de la fenêtre latérale. Les chats entre collaborateurs uniquement ne sont pas listés.",
  "gcAllRooms": "Tous les groupes",
  "colGroup": "Groupe",
  "colAskedBy": "Posée par",
  "colCatchyAnswer": "Réponse de Catchy",
  "colContext": "Avant",
  "gcSide": "Fenêtre latérale",
  "gcNoLog": "Catchy n'a encore répondu dans aucun chat de groupe.",
  "usage": "Utilisation des données IA",
  "colWhen": "Quand",
  "colWho": "Qui",
  "colWhat": "Quoi",
  "details": "Détails",
  "wAddFile": "Fichier « {{t}} » ajouté",
  "wAddInstr": "Instruction « {{t}} » ajoutée",
  "wNewFile": "Nouvelle version de « {{t}} » importée (v{{v}})",
  "wEditInstr": "Instruction « {{t}} » modifiée (v{{v}})",
  "wRetire": "« {{t}} » désactivé — Catchy ne l'utilise plus",
  "wRestore": "« {{t}} » activé — Catchy l'utilise de nouveau",
  "wRollback": "« {{t}} » ramené à la v{{from}} (désormais v{{to}})",
  "wPropose": "Leçon proposée : « {{q}} »",
  "wProposeChat": "Leçon proposée depuis le chat : « {{q}} »",
  "wApprove": "Leçon « {{q}} » approuvée",
  "wReject": "Leçon « {{q}} » rejetée",
  "wRetireLesson": "Leçon « {{q}} » retirée",
  "wUp": "Réponse à « {{q}} » notée utile",
  "wDown": "Réponse à « {{q}} » notée incorrecte",
  "wClear": "Note supprimée pour « {{q}} »",
  "dType": "Type",
  "dTitle": "Titre",
  "dVersion": "Version",
  "dFrom": "De",
  "dTo": "À",
  "dFile": "Nom du fichier",
  "dSize": "Taille",
  "dChars": "Texte lu (caractères)",
  "dPassages": "Passages",
  "dQuestion": "Question",
  "dAnswer": "Bonne réponse",
  "dStatus": "Statut",
  "dProposedBy": "Proposée par",
  "dSaid": "Ce qui a été saisi dans le chat",
  "dRating": "Note",
  "dNote": "Remarque",
  "dText": "Texte",
  "kindFile": "Fichier",
  "kindInstr": "Instruction",
  "before": "Avant",
  "after": "Après",
  "mineOnly": "Uniquement les miens",
  "everybody": "Ceux de tous",
  "fbAll": "Toutes les notes",
  "fbUp": "Utile",
  "fbDown": "Incorrect",
  "noRows": "Rien pour l'instant.",
  "spent": "Dépenses IA aujourd'hui : {{a}} sur {{c}} (toutes les fonctionnalités du portail confondues) · ce mois-ci {{m}}",
  "colAsks": "Questions",
  "colCost": "Coût",
  "wholeHub": "Tous les départements (aucun département choisi)",
  "keptOff": "laissé désactivé",
  "turnOff": "Désactiver",
  "useNow": "Actif immédiatement — Catchy utilise cette version dès son enregistrement",
  "activeOffHint": "Catchy n'utilise pas ce document — cliquez pour l'activer",
  "activeOnHint": "Catchy utilise ce document — cliquez pour le désactiver",
  "activeOff": "Désactivé",
  "activeOn": "Activé",
  "colActive": "Actif",
  "search": "Rechercher…",
  "shown": "{{n}} sur {{total}}",
  "fWhoAll": "Tout le monde",
  "fKindAll": "Tous types de modifications",
  "fKindDocs": "Fichiers et instructions",
  "fKindLessons": "Leçons",
  "fKindRatings": "Notes",
  "loading": "Chargement…"
};
const ja = {
  "placeholderTouch": "Catchy に質問…",
  "photo": "写真を追加（カメラまたはギャラリー）",
  "photoAsk": "この写真には何が写っていますか？",
  "movedTo": "E-Docs {{code}} に移動しました — Catchy はそこで読み取ります",
  "fromHub": "Catchy Chat",
  "bubbleBack": "チャットに戻る",
  "bubbleConvs": "会話一覧",
  "openInHub": "Catchy Chat を開く",
  "fromBubble": "Ask Catchy",
  "showOriginal": "原文を表示",
  "trMark": "AI がポータルの言語に翻訳しました",
  "trFailed": "翻訳できませんでした",
  "pTitle": "ポータル全体の AI 利用額（管理者のみ）",
  "pTotal": "合計 {{a}}",
  "pKeys": "API キー（ユーザー用）：{{u}} · SYSTEM 用：{{s}}",
  "keyOwn": "専用キー",
  "keyShared": "共有キー",
  "pByWho": "ユーザー別（SYSTEM = 自動ジョブ）",
  "pByFeature": "機能別",
  "pBySystem": "SYSTEM（実行場所別）",
  "pPrices": "モデル価格、100 万トークンあたりの USD（新規の呼び出しはすべてこの表で課金計算されます）",
  "kindUser": "ユーザー",
  "kindOld": "27/10 以前（未記録）",
  "colCalls": "呼び出し数",
  "colTokIn": "入力トークン",
  "colTokOut": "出力トークン",
  "colFeature": "機能",
  "colBy": "実行者",
  "colWhere": "場所",
  "colModel": "モデル",
  "colIn": "入力",
  "colOut": "出力",
  "colChanged": "最終変更",
  "change": "変更",
  "nav": "Catchy Chat",
  "navAsk": "Catchy Chat",
  "navSettings": "設定",
  "backToChat": "Catchy Chat に戻る",
  "navKnowledge": "Knowledge Library",
  "navLessons": "レッスン",
  "navActivity": "アクティビティ",
  "title": "Catchy Chat",
  "sub": "各部門が指示とファイルを共有し、誰でもそれらについて質問できます。すべての回答には情報源が表示されます。誤りがあれば修正でき、誰かが修正を承認すると、以降 AI はその修正を使います。",
  "tabAsk": "Catchy Chat",
  "tabKnowledge": "Knowledge Library",
  "tabLessons": "レッスン",
  "tabActivity": "管理",
  "scope": "部門",
  "allDepts": "すべての部門",
  "general": "すべての部門（全般）",
  "generalHint": "後から追加された部門を含め、すべての部門に適用されます",
  "generalAdminOnly": "全般のレッスンは Admin が判断します",
  "placeholder": "部門が共有した内容や、ポータル内のあらゆる情報について質問してください…",
  "send": "質問",
  "thinking": "ドキュメントを確認しています…",
  "think1": "Claude があなたの質問を読んでいます…",
  "think2": "Claude がドキュメントとポータルを確認しています…",
  "think3": "Claude が回答を作成しています…",
  "newChat": "新しい会話",
  "emptyAsk": "部門のドキュメントや、ポータル内のあらゆる情報（SKU とその工程、サンプル、チケット、OPA / SCT、売上）について質問できます。回答には出典が表示されます。",
  "fromPortal": "ポータルより",
  "captured": "レッスン案として記録しました（{{d}}）",
  "capturedApproved": "レッスンを承認しました — 以降 AI が使用します",
  "capturedDropped": "レッスンを破棄しました",
  "approveNow": "今すぐ承認",
  "dropIt": "破棄する",
  "convs": "会話",
  "noConvs": "保存された会話はまだありません。",
  "turns": "{{n}} 件の質問",
  "rename": "名前を変更",
  "delete": "削除",
  "confirmDelConv": "「{{t}}」を一覧から削除しますか？質問内容はアクティビティログに残ります。",
  "renamePrompt": "この会話の名前を入力してください",
  "sources": "情報源",
  "lesson": "レッスン",
  "instruction": "指示",
  "approvedBy": "{{n}} 人が承認",
  "part": "パート {{n}}",
  "good": "役に立った",
  "bad": "正しくない",
  "rated": "ありがとうございます。記録しました。",
  "fixTitle": "正しい回答は何ですか？",
  "fixSub": "正しい回答を入力してください。レッスン案として登録され、レッスンで誰かが承認すると AI が使用します。",
  "fixNote": "どこが誤っていたか（任意）",
  "fixAnswer": "正しい回答",
  "fixDept": "対象の部門",
  "deptsHint": "複数選択できます",
  "deptsPick": "部門を選択…",
  "deptsSearch": "部門を検索",
  "deptsChosen": "{{n}} 件選択中",
  "deptsDone": "完了",
  "fixSend": "レッスンを提案",
  "justRate": "評価のみ",
  "cancel": "キャンセル",
  "close": "閉じる",
  "proposed": "提案済み — レッスンで誰かが承認すると AI が使用します。",
  "depts": "部門",
  "youManage": "あなたが管理しています",
  "counts": "指示 {{i}} 件 · ファイル {{f}} 件 · レッスン {{l}} 件",
  "waiting": "{{n}} 件待機中",
  "instructions": "指示",
  "files": "ファイル",
  "noInstr": "指示はまだありません。",
  "noFiles": "ファイルはまだありません。",
  "newInstr": "新しい指示",
  "uploadFile": "ファイルをアップロード",
  "colTitle": "タイトル",
  "colVersion": "バージョン",
  "colUpdated": "更新日",
  "colSize": "サイズ",
  "colAction": "操作",
  "colPassages": "パッセージ",
  "colNote": "備考",
  "actView": "表示",
  "actEdit": "編集",
  "actNewVersion": "新バージョン",
  "actHistory": "履歴",
  "actRetire": "停止する",
  "actRestore": "戻す",
  "actDownload": "ダウンロード",
  "actRollback": "このバージョンを使用",
  "retired": "使用停止中",
  "instrTitle": "タイトル",
  "instrText": "指示",
  "instrNote": "この変更の理由（ログに保存されます）",
  "instrHint": "この部門について AI がどう回答すべきかを指示してください：ルール、使用すべき事実、トーンなど。",
  "save": "保存",
  "fileHint": "PDF、Word、PowerPoint、Excel、テキスト、CSV、HTML、最大 15 MB。スキャンした PDF には読み取れるテキストがありません。",
  "fileTitle": "タイトル",
  "chooseFile": "ファイルを選択",
  "uploading": "ファイルを読み込んでいます…",
  "uploaded": "v{{v}} を保存しました — {{p}} パッセージ。",
  "readOnly": "この部門のナレッジを変更できるのは、部門の管理者（または Catchy Chat の管理者）のみです。",
  "historyTitle": "履歴 — {{t}}",
  "current": "現行",
  "confirmRetire": "「{{t}}」をオフにしますか？再びオンにするまで、Catchy は使用しません。",
  "confirmRollback": "v{{v}} を再び現行バージョンにしますか？新しいバージョンとして保存されます。",
  "viewText": "AI が読み取るテキスト",
  "lessonsSub": "レッスンとは、修正された回答のことです。提案中のレッスンは、誰かが承認するまで使用されません。",
  "newLesson": "レッスンを提案",
  "stProposed": "提案済み",
  "stApproved": "承認済み",
  "stRejected": "却下済み",
  "stRetired": "停止済み",
  "stAll": "すべて",
  "colQuestion": "質問",
  "colAnswer": "正しい回答",
  "colDept": "部門",
  "colProposed": "提案日",
  "colDecided": "決定日",
  "colStatus": "ステータス",
  "actApprove": "承認",
  "actReject": "却下",
  "actRetireLesson": "停止",
  "decideTitle": "このレッスンを{{d}}しますか？",
  "decideNote": "備考（ログに保存されます）",
  "noLessons": "レッスンはまだありません。",
  "log": "変更ログ",
  "questions": "質問",
  "groups": "グループチャット",
  "gcDigestTitle": "グループチャットの問題とアイデア（AI）",
  "gcDigestHint": "Catchy が有効なグループチャットを読み取り、挙がった問題・質問・改善アイデアを画面やトピックごとに一覧にします。名前や引用は含みません。16:00 のレポートとともに、または今すぐ作成されます。",
  "gcSummarise": "今すぐ要約",
  "gcSummarised": "要約しました：{{m}} 件のメッセージから {{n}} 件のトピック。",
  "gcNothing": "要約するための新しいメッセージが足りません。",
  "gcNoDigest": "要約はまだありません。",
  "gcPeriod": "{{from}} – {{to}} · {{rooms}} グループ、{{msgs}} 件のメッセージ",
  "gcOlder": "過去の要約",
  "gcKind_problem": "問題",
  "gcKind_question": "質問",
  "gcKind_idea": "アイデア",
  "gcLogTitle": "グループチャットでの Catchy",
  "gcLogHint": "Catchy への質問ごとに、その回答と直前のメッセージ、およびサイドウィンドウへの投稿を表示します。社員同士のみのチャットは表示されません。",
  "gcAllRooms": "すべてのグループ",
  "colGroup": "グループ",
  "colAskedBy": "質問者",
  "colCatchyAnswer": "Catchy の回答",
  "colContext": "直前",
  "gcSide": "サイドウィンドウ",
  "gcNoLog": "Catchy はまだどのグループチャットでも回答していません。",
  "usage": "AI データ使用状況",
  "colWhen": "日時",
  "colWho": "実行者",
  "colWhat": "内容",
  "details": "詳細",
  "wAddFile": "ファイル「{{t}}」を追加しました",
  "wAddInstr": "指示「{{t}}」を追加しました",
  "wNewFile": "「{{t}}」の新バージョンをアップロードしました（v{{v}}）",
  "wEditInstr": "指示「{{t}}」を変更しました（v{{v}}）",
  "wRetire": "「{{t}}」をオフにしました — Catchy は使用しません",
  "wRestore": "「{{t}}」をオンにしました — Catchy が再び使用します",
  "wRollback": "「{{t}}」を v{{from}} に戻しました（現在 v{{to}}）",
  "wPropose": "レッスンを提案しました：「{{q}}」",
  "wProposeChat": "チャットからレッスンを提案しました：「{{q}}」",
  "wApprove": "レッスン「{{q}}」を承認しました",
  "wReject": "レッスン「{{q}}」を却下しました",
  "wRetireLesson": "レッスン「{{q}}」を停止しました",
  "wUp": "「{{q}}」への回答を「役に立った」と評価しました",
  "wDown": "「{{q}}」への回答を「正しくない」と評価しました",
  "wClear": "「{{q}}」の評価を取り消しました",
  "dType": "種類",
  "dTitle": "タイトル",
  "dVersion": "バージョン",
  "dFrom": "変更元",
  "dTo": "変更先",
  "dFile": "ファイル名",
  "dSize": "サイズ",
  "dChars": "読み取ったテキスト（文字数）",
  "dPassages": "パッセージ",
  "dQuestion": "質問",
  "dAnswer": "正しい回答",
  "dStatus": "ステータス",
  "dProposedBy": "提案者",
  "dSaid": "チャットに入力された内容",
  "dRating": "評価",
  "dNote": "備考",
  "dText": "テキスト",
  "kindFile": "ファイル",
  "kindInstr": "指示",
  "before": "変更前",
  "after": "変更後",
  "mineOnly": "自分のみ",
  "everybody": "全員分",
  "fbAll": "すべての評価",
  "fbUp": "役に立った",
  "fbDown": "正しくない",
  "noRows": "まだありません。",
  "spent": "本日の AI 利用額 {{a}} / {{c}}（ポータルの全機能の合計）· 今月 {{m}}",
  "colAsks": "質問数",
  "colCost": "コスト",
  "wholeHub": "すべての部門（部門の指定なし）",
  "keptOff": "オフのまま",
  "turnOff": "オフにする",
  "useNow": "すぐに有効 — 保存するとすぐに Catchy がこのバージョンを使用します",
  "activeOffHint": "Catchy はこのドキュメントを使用していません — クリックしてオンにします",
  "activeOnHint": "Catchy はこのドキュメントを使用しています — クリックしてオフにします",
  "activeOff": "オフ",
  "activeOn": "オン",
  "colActive": "有効",
  "search": "検索…",
  "shown": "{{n}} / {{total}}",
  "fWhoAll": "全員",
  "fKindAll": "すべての種類の変更",
  "fKindDocs": "ファイルと指示",
  "fKindLessons": "レッスン",
  "fKindRatings": "評価",
  "loading": "読み込み中…"
};

const dictionary = { ns: 'xAiHub', en, ko, vi, zh, fr, ja };
export default dictionary;
